"use client";

import GoogleIcon from "@/assets/icons/googleIcon";
import { useRegisterMutation } from "@/components/parts/register/api";
import {
  RegisterPayload,
  registerValidation,
} from "@/components/parts/register/validation";
import GoogleButton from "@/components/shared/button/googleButton";
import { CustomFormInput } from "@/components/shared/forms/customFormInput";
import CustomFormSnk from "@/components/shared/forms/customFormSnk";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { zodResolver } from "@hookform/resolvers/zod";
import Link from "next/link";
import { useRouter, useSearchParams } from "next/navigation";
import { useForm } from "react-hook-form";

export default function RegisterPage() {
  const router = useRouter();
  const params = useSearchParams();
  const callback = params.get("callback") ?? "";

  const form = useForm<RegisterPayload>({
    resolver: zodResolver(registerValidation),
    defaultValues: {
      email: "",
      phone: "",
      password: "",
      roleId: 1,
      name: "",
    },
  });
  const { handleSubmit } = form;

  const registerMutation = useRegisterMutation();

  const onSubmit = (data: RegisterPayload) => {
    registerMutation.mutate(data, {
      onSuccess: () => {
        router.push(`/login?${callback}`);
      },
    });
  };

  return (
    <section className="flex-1">
      {/* Form */}
      <Form {...form}>
        <form className="flex flex-col gap-4" onSubmit={handleSubmit(onSubmit)}>
          <CustomFormInput<RegisterPayload>
            name="name"
            label="Nama"
            placeholder="Masukkan nama"
            labelClassName="text-base text-white"
          />
          <CustomFormInput<RegisterPayload>
            name="email"
            label="Email"
            placeholder="Masukkan email"
            labelClassName="text-base text-white"
          />
          <CustomFormInput<RegisterPayload>
            name="phone"
            label="Nomor Telepon"
            placeholder="Masukkan nomor telepon"
            labelClassName="text-base text-white"
          />
          <CustomFormInput<RegisterPayload>
            type="password"
            name="password"
            label="Password"
            placeholder="Masukkan password"
            labelClassName="text-base text-white"
          />
          <CustomFormSnk<RegisterPayload> name="isTermsAndConditions" />
          <Button
            type="submit"
            className="py-3 rounded-full px-10 mx-auto my-1 w-72 bg-white hover:bg-slate-100 text-primary-700"
          >
            Daftar
          </Button>
        </form>
      </Form>

      {/* Google Login */}
      <GoogleButton />

      {/*  */}
      <div className=" gap-1 items-center text-white mt-10 flex justify-center">
        Sudah punya akun?
        <Link
          href={`/login?${params.toString()}`}
          className="text-white font-semibold underline"
        >
          Masuk
        </Link>
      </div>
    </section>
  );
}
